import {
    SliceFactory,
    FetchCollectionData,
    FetchItemDataType,
    ApiCollectionResponse,
} from '@europrocurement/l2d-redux-utils';
import { filterDeletedCollection } from '@europrocurement/l2d-domain/utils/filterDeletedCollection';
import {
    ConfigurationParameters as OffreConfigurationParameters,
    Configuration,
    GroupementApi,
    GroupementGroupementRead,
    GroupementApiApiGroupementsGetCollectionRequest,
} from '../../../openApi/ApiOffre';
import { OFFER_GROUP_SLICE_NAME, OFFRE_REDUCER_NAME } from '../constants';

export type OfferGroupApiObject = GroupementGroupementRead & Record<string, unknown>;

export type OfferGroup = OfferGroupApiObject;

export const mapperOfferGroups = function (offerGroup: OfferGroupApiObject) {
    return {
        ...offerGroup,
    } as OfferGroup;
};

export function createOfferGroupSlice(configuration: OffreConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new GroupementApi(conf);

    const fetchOfferGroupsCollection: FetchCollectionData<OfferGroupApiObject> = ({
        search,
        pagination: { page, itemsPerPage },
        filters,
        xIdSociete,
        orders,
    }) => {
        let multiFieldSearch: string | undefined;
        let domaineId: number | undefined;
        let orderRang: 'asc' | 'desc' | undefined;

        if (search && search !== '') {
            multiFieldSearch = search;
        }

        if (filters.domaineId) {
            domaineId = filters.domaineId as number;
        }

        if (orders && orders.length > 0) {
            const orderItem = orders[0];
            if (orderItem.field === 'rang') {
                orderRang = orderItem.value;
            }
        }

        const requestParameters: GroupementApiApiGroupementsGetCollectionRequest = {
            page: page + 1,
            itemsPerPage,
            domaineSocietesSocieteId: xIdSociete,
            domaineId,
            multiFieldSearch,
            orderRang,
        };

        return api
            .apiGroupementsGetCollection(requestParameters)
            .then((res) => filterDeletedCollection(res.data))
            .catch((error) => {
                console.error(error);
            }) as Promise<ApiCollectionResponse<OfferGroupApiObject>>;
    };

    const fetchOfferGroupsItem: FetchItemDataType<OfferGroupApiObject> = ({
        idItem,
        // pagination,
    }) =>
        api
            .apiGroupementsIdGet({ id: String(idItem) })
            .then((res) => res.data) as Promise<OfferGroupApiObject>;

    const { slice: offerGroupsSlice, dataSourcesThunks: offerGroupsDataSourcesThunks } =
        SliceFactory.createSlice<OfferGroupApiObject, OfferGroup>(
            OFFER_GROUP_SLICE_NAME,
            OFFRE_REDUCER_NAME,
            [],
            fetchOfferGroupsCollection,
            fetchOfferGroupsItem,
            mapperOfferGroups,
            undefined,
            undefined,
            [{ field: 'rang', value: 'asc' }],
        );

    return { offerGroupsSlice, offerGroupsDataSourcesThunks };
}
